export const urlUtils = () => {
  const normalizeUrlWithTrailingSlash = (url) => {
    if (!url) {
      return "/";
    }
    if (url.endsWith("/")) {
      return url;
    } else {
      return `${url}/`;
    }
  }

  return {
    normalizeUrlWithTrailingSlash,
  }
}